<div class="mt-4" [formGroup]="formGroup">
  <span
    class="text-md font-semibold mb-3 card-title"
    [ngClass]="{ required: fields.isRequired }"
  >
    {{ fields.displayName }}
  </span>

  <!--  Skeleton -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4" *ngIf="isLoading">
    <div
      *ngFor="let i of skeletonArray"
      class="relative border rounded-xl p-5 flex items-start gap-4 bg-white dark:bg-coal-700"
    >
      <!-- Logo -->
      <div
        class="w-10 h-10 rounded-circle shimmer-item bg-gray-300 dark:bg-coal-700"
      ></div>

      <!-- Text -->
      <div class="flex flex-col gap-2 flex-1">
        <div
          class="w-36 h-4 rounded shimmer-item bg-gray-300 dark:bg-coal-700"
        ></div>
        <div
          class="w-48 h-4 rounded shimmer-item bg-gray-300 dark:bg-coal-700"
        ></div>
      </div>

      <!-- button -->
      <div
        class="w-20 h-10 rounded shimmer-item bg-gray-300 dark:bg-coal-700"
      ></div>
    </div>
  </div>

  <!-- Card Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
    <ng-container *ngFor="let option of fieldsData">
      <div
        *ngIf="option._id != 'None'"
        [ngClass]="{
          'border-success border-3': isSelected(option),
          'border-gray-300 opacity-50': isDisabled(option),
          'border-gray-300': !isSelected(option) && !isDisabled(option),
          'disabled-card': isDisabled(option),
        }"
        class="relative flex flex-col p-5 border bg-no-repeat bg-cover rounded-md h-[150px] hover:bg-secondary-active"
        [class.pointer-events-none]="isDisabled(option)"
      >
        <!-- Check icon -->
        <div class="flex items-center justify-between relative min-h-[32px]">
          <i
            class="absolute ki-solid ki-check-circle text-xl text-success transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': isSelected(option),
              'opacity-0': !isSelected(option),
            }"
          >
          </i>

          <!-- Center Radio -->
          <input
            class="appearance-none"
            name="appearance_option"
            type="radio"
            value="2"
          />

          <!-- Right-side eye -->
          <!-- <i
            *ngIf="
              option.fieldDependencies &&
              option.name !== 'Jira' &&
              option.name !== 'Asana'
            "
            class="absolute ki-outline ki-eye text-xl text-gray-600 transition-opacity duration-200 right-0 cursor-pointer"
            (click)="openConnect(option, 'connection_modal')"
            [ngClass]="{
              'opacity-100': isSelected(option),
              'opacity-0': !isSelected(option)
            }"
          >
          </i> -->
        </div>

        <!-- Card Content -->
        <div class="flex items-center justify-between gap-4 mt-2">
          <div
            class="flex items-center gap-2.5"
            [ngClass]="{ 'disabled-card': isDisabled(option) }"
          >
            <div class="relative size-[44px] shrink-0">
              <img
                [src]="option.iconUrl"
                class="w-[56px] h-[56px]"
                (error)="handleImageError(option, $event)"
              />
            </div>
            <div class="flex flex-col">
              <a
                class="text-base font-semibold text-gray-900 hover:text-primary-active mb-px"
              >
                {{ option.name }}
              </a>
              <span class="text-sm font-medium text-gray-600">
                {{ option.subText }}
              </span>
            </div>
          </div>

          <!-- Connect/Disconnect Buttons -->
          <button
            *ngIf="!isSelected(option)"
            class="btn btn-sm btn-primary ms-auto transition-opacity duration-200"
            [disabled]="isDisabled(option)"
            (click)="toggleSelection(option, 'connect')"
          >
            <div
              class="loader"
              *ngIf="loadingCards.has(option._id?.toString())"
            ></div>
            <i
              class="ki-filled ki-plus-squared text-lg"
              *ngIf="!loadingCards.has(option._id?.toString())"
            ></i>
            Connect
          </button>

          <button
            *ngIf="isSelected(option)"
            class="btn btn-sm btn-secondary ms-auto transition-opacity duration-200"
            (click)="toggleSelection(option, 'disconnect')"
          >
            <i class="ki-filled ki-minus-squared text-lg"></i>
            Disconnect
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Validation Error -->
  <div *ngIf="showValidationError" class="text-sm text-danger mt-2">
    Please select an option.
  </div>
</div>

<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'connection_modal_' + fields.fieldName"
>
  <div
    class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg bg-white shadow-lg dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="card-title font-semibold text-base ms-2">{{
        modalTitle
      }}</span>
    </div>
    <div class="modal-body gap-5 p-4">
      <app-modal-renderer
        #modalRendererRef
        *ngIf="activeModalContext"
        [nodeId]="currentNodeId"
        (formSaved)="onModalFormSaved($event)"
        (closeModal)="closeModal('connection_modal_' + fields.fieldName)"
        [workflowData]="workflowData"
        [recordID]="recordID"
        [workflowId]="workflowId"
        (clickedOnPrevious)="clickedOnPrevious()"
        (header)="setModalTitle($event)"
        (checkPollingServiceForError)="checkPollingServiceForError($event)"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>

<!-- ── Coming Soon Modal ────────────────────────────────── -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'coming_soon_modal_' + fields.fieldName"
>
  <div class="coming-soon-modal-content bg-white dark:bg-coal-500">
    <!-- Rocket Icon Area -->
    <div class="rocket-container">
      <div class="rocket-circle">
        <!-- Golden/Yellow Rocket SVG -->
        <svg class="rocket-icon" viewBox="0 0 24 24" fill="none">
          <!-- Rocket Body -->
          <path
            d="M4.5 16.5c-1.5 1.5-2.5 3.5-2.5 5.5 2-.001 4-1 5.5-2.5l11.084-11.084c.828-.828.828-2.17 0-3-.828-.828-2.17-.828-3 0L4.5 16.5z"
            fill="#EAB308"
            stroke="#EAB308"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <!-- Wings / Fins -->
          <path d="M12 9l-4-4c-.75.75-1.5 1.75-2 3l3 3 3-2z" fill="#CA8A04" />
          <path d="M15 12l-4-4c.75-.75 1.75-1.5 3-2l3 3-2 3z" fill="#CA8A04" />
          <!-- Flame -->
          <path
            d="M2.5 21.5c.5-1.5 1.5-2 2-2.5s1-.5 1-1"
            stroke="#F97316"
            stroke-width="2"
            stroke-linecap="round"
          />
          <!-- Window/Dot -->
          <circle cx="14.5" cy="9.5" r="1.5" fill="#1e2b48" />
        </svg>
      </div>
      <!-- Tiny Sparkles / Stars -->
      <span class="sparkle sparkle-1">✦</span>
      <span class="sparkle sparkle-2">✦</span>
      <span class="sparkle sparkle-3">✦</span>
      <span class="sparkle sparkle-4">✦</span>
      <span class="sparkle sparkle-5">✦</span>
    </div>

    <!-- Title & Content -->
    <h3 class="coming-soon-title text-gray-800">Coming Soon!</h3>
    <p class="coming-soon-text">
      We're working hard to bring this integration to you.<br />
      Stay tuned – Exciting things are on the way!
    </p>

    <!-- Got It Button -->
    <button
      type="button"
      class="coming-soon-btn btn btn-sm btn-brand-primary"
      (click)="closeModal('coming_soon_modal_' + fields.fieldName)"
    >
      Got It
    </button>
  </div>
</div>
